<template lang="pug">
  v-dialog(v-model='dialog' scrollable persistent max-width='80%')
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        span.headline {{ formTitle }} Nro {{ this.editedItem.numFactura }}
      v-divider
      v-card-text
        v-row(dense)
          v-col(cols='12')
            v-card(color='white')
              v-card-text
                v-row(dense)
                  v-col(cols='6' sm='6' md='4')
                    v-autocomplete(dense label="Tipo de Nota de Credito" id="tipoN" autocomplete="off" outlined v-model='editedItem.idTipoNotaCredito' :items="idTipoNotaCreditoArray" @change="changeTipoNota()")
                  v-col(cols='12' sm='12' md='12')
                    v-textarea(auto-grow, v-model='editedItem.observacion', label="Observacion", outlined, dense, v-uppercase)
          v-col(cols='12')
            v-card(color='white')
              v-card-text
                v-row(dense)
                  v-col(cols='12' sm='12' md='12')
                    v-data-table.elevation-1(:headers='headers' :items='productos' :search='search' :loading='loading' loading-text='Cargando, por favor espere...')
                      template(v-if="devolP" v-slot:item.devuelto='props')
                        v-text-field(v-model.number='props.item.devuelto' @input='changeNota(props.item)', type="number", min="0", label='Cant. Devolver', single-line)
                      template(v-if="devolT || devolP" v-slot:item.idAlmacen='props')
                        v-autocomplete(v-model='props.item.idAlmacen' autocomplete="off" :items="idAlmacenArray")
                      template(v-slot:top)
                        v-toolbar(flat color='primary' dark)
                          v-toolbar-title Nota de Credito
                          v-divider.mx-4(inset vertical)
                          v-spacer
                          v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success')
                          v-spacer
                      template(v-slot:no-data)
                        h1 No hay Productos Asociados
                p
                v-row(v-if='desc' dense)
                  v-col(cols='12' sm='12' md='4')
                    v-text-field(dense v-model.number='editedItem.descuento', outlined label='Porcentaje de Descuento', @input='changeNota(editedItem)')
          v-col(cols='12')
            v-card(color='white')
              v-card-subtitle.title(style='color: black') Montos
              v-card-text
                v-row(class='d-flex justify-end')
                  v-col(cols='3' sm='3' md='3')
                    v-text-field(dense readonly :value='editedItem.subTotal | read', outlined label='Subtotal')
                  v-col(cols='3' sm='3' md='3')
                    v-text-field(dense readonly :value='editedItem.gravado | read', outlined label='Gravado')
                  v-col(cols='3' sm='3' md='3')
                    v-text-field(dense readonly :value='editedItem.exento | read', outlined label='Exento')
                  v-col(cols='3' sm='3' md='3')
                    v-text-field(dense readonly :value='editedItem.total | read', outlined label='Total + IVA')
      v-card-actions
        v-spacer
        v-btn(color='error' small dark @click='close')
          v-icon mdi-close
          | Cancelar
        v-btn(color='success' small dark @click='save')
          v-icon mdi-content-save
          | Generar
    FacturaNotaCredito(:dialogFacturaNotaCredito='dialogFacturaNotaCredito' @close = 'closeF')
    FacturaNotaCreditoDescuento(:dialogFacturaNotaCreditoDescuento='dialogFacturaNotaCreditoDescuento' @close = 'closeF2')
</template>

<script>
import Api from '@/services/methods'
// eslint-disable-next-line no-unused-vars
import { EventBus } from '../../Events'
import FacturaNotaCredito from '../../components/reportes/FacturaNotaCredito'
import FacturaNotaCreditoDescuento from '../../components/reportes/FacturaNotaCreditoDescuento'
export default {
  props: ['dialog', 'FormPadre', 'productos'],
  data: () => ({
    dialogFacturaNotaCredito: false,
    dialogFacturaNotaCreditoDescuento: false,
    read: false,
    loading: true,
    headers: [
      { text: 'Codigo', value: 'idProducto.nombre' },
      { text: 'Nombre', value: 'idProducto.descripcion' },
      { text: 'Cant. Actual ', value: 'cantidadActual' },
      { text: 'Despachada ', value: 'despachada' },
      { text: 'Precio', value: 'precio' },
      { text: 'Sub Total', value: 'subTotal' },
      { text: 'IVA', value: 'idIva.descripcion' },
      { text: 'Monto Total', value: 'total' }
    ],
    descripcionNota: '',
    devolP: false,
    devolT: false,
    desc: false,
    search: '',
    permisosRuta: {},
    pedidos: [],
    vendedores: [],
    clientes: [],
    tipoNotaCredito: [],
    idTipoNotaCreditoArray: [],
    almacen: [],
    idAlmacenArray: [],
    editedIndex: -1,
    editedItem: {
      idTipoNotaCredito: '',
      idCliente: '',
      idPedido: '',
      numFactura: '',
      numeroPedido: '',
      observacion: '',
      detalleProducto: [],
      fechaVencimiento: '',
      subTotal: 0,
      gravado: 0,
      exento: 0,
      baseImponible: 0,
      total: 0,
      debito: 0,
      credito: 0,
      tipoVenta: '',
      despachada: 0
    },
    defaultItem: {
      idTipoNotaCredito: '',
      idCliente: '',
      idPedido: '',
      numFactura: '',
      numeroPedido: '',
      observacion: '',
      detalleProducto: [],
      fechaVencimiento: '',
      subTotal: 0,
      gravado: 0,
      exento: 0,
      baseImponible: 0,
      total: 0,
      debito: 0,
      credito: 0,
      tipoVenta: '',
      despachada: 0
    },
    form: {}
  }),

  components: {
    FacturaNotaCredito,
    FacturaNotaCreditoDescuento
  },

  computed: {
    formTitle () {
      return 'Factura'
    }
  },
  
  watch: {
    dialog (val) {
      val || this.close()
    },
    FormPadre (val) {
      // formulario que llega del padre, para editar y ver
      if (Object.keys(val).length !== 0) {
        this.editedItem = val
        this.editedItem.observacion = ''
        this.editedItem.idTipoNotaCredito = ''
        this.loading = false
        this.editedItem.subTotal = 0
        this.editedItem.gravado = 0
        this.editedItem.exento = 0
        this.editedItem.baseImponible = 0
        this.editedItem.total = 0
        for (let i = 0; i < this.editedItem.detalleProducto.length; i++) {
          this.editedItem.detalleProducto[i].devuelto = 0
          this.editedItem.detalleProducto[i].subTotal = 0
          this.editedItem.detalleProducto[i].total = 0
        }
        this.headers = [
          { text: 'Codigo', value: 'idProducto.nombre' },
          { text: 'Nombre', value: 'idProducto.descripcion' },
          { text: 'Cant. Actual ', value: 'cantidadActual' },
          { text: 'Despachada ', value: 'despachada' },
          { text: 'Precio(Bs)', value: 'precioBs' },
          { text: 'Sub Total', value: 'subTotal' },
          { text: 'IVA', value: 'idIva.descripcion' },
          { text: 'Monto Total', value: 'total' }
        ]
      }
    },
    'devolP': function (val) {
      if (val) {
        this.headers.splice(4, 0, {
          text: 'Cant. Devolver',
          value: 'devuelto',
          filterable: false
        }, {
          text: 'Almacen',
          value: 'idAlmacen',
          filterable: false
        })
      }
    },
    'devolT': function (val) {
      if (val) {
        this.headers.splice(4, 0, {
          text: 'Cant. Devolver',
          value: 'devuelto',
          filterable: false
        }, {
          text: 'Almacen',
          value: 'idAlmacen',
          filterable: false
        })
      }
    }
  },

  created () {
    this.initialize()
    // this.permisosRuta = this.$store.state.empresa[0].permisos.find(
    //   permiso => permiso.ruta == "Producto"
    // );
  },
  methods: {
    initialize () {
      this.listarTipoNotaCredito()
      this.listarAlmacenes()
    },

    listarTipoNotaCredito () {
      Api.get('/tiponotacredito')
        .then(res => {
          this.tipoNotaCredito = res.data
          this.tipoNotaCredito.map(data => {
            this.idTipoNotaCreditoArray.push({
              text: data.descripcion,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
             // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    listarAlmacenes () {
      Api.get('/almacen')
        .then(res => {
          this.almacen = res.data
          this.almacen.map(data => {
            this.idAlmacenArray.push({
              text: data.descripcion,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
             // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    calculosP (val) {
      this.editedItem.subTotal = 0
      this.editedItem.gravado = 0
      this.editedItem.exento = 0
      this.editedItem.baseImponible = 0
      this.editedItem.total = 0

      val.total = 0
      if (val.idIva.descripcion === 'Normal (16%)') {
        val.baseImponible = (val.precioBs * val.devuelto) 
        val.gravado += ((val.precioBs) * 0.16)
        val.total = val.gravado + val.subTotal
      } else if (val.idIva.descripcion === 'Reducido (8%)') {
        val.baseImponible = (val.precioBs * val.devuelto) 
        val.gravado += ((val.precioBs) * 0.08)
        val.total = val.gravado + val.subTotal
      } else {
        val.exento += val.precioBs
        val.total = val.exento
      }
      for (let i = 0; i < this.editedItem.detalleProducto.length; i++) {
        this.editedItem.subTotal += this.editedItem.detalleProducto[i].subTotal
        this.editedItem.gravado += this.editedItem.detalleProducto[i].gravado
        this.editedItem.exento += this.editedItem.detalleProducto[i].exento
        this.editedItem.baseImponible += this.editedItem.detalleProducto[i].baseImponible
      }
      this.editedItem.total = Math.round(this.editedItem.subTotal + this.editedItem.gravado)
    },

    calculosT () {
      this.editedItem.subTotal = 0
      this.editedItem.gravado = 0
      this.editedItem.exento = 0
      this.editedItem.baseImponible = 0
      this.editedItem.total = 0
      if (this.editedItem.detalleProducto.length > 0) {
        for (let i = 0; i < this.editedItem.detalleProducto.length; i++) {
          this.editedItem.detalleProducto[i].total = 0
          if (this.editedItem.detalleProducto[i].idIva.descripcion === 'Normal (16%)') {
            this.editedItem.detalleProducto[i].baseImponible = (this.editedItem.detalleProducto[i].precioBs * this.editedItem.detalleProducto[i].devuelto)
            this.editedItem.detalleProducto[i].gravado += ((this.editedItem.detalleProducto[i].precioBs) * 0.16)
            this.editedItem.detalleProducto[i].total = this.editedItem.detalleProducto[i].gravado + this.editedItem.detalleProducto[i].subTotal
          } else if (this.editedItem.detalleProducto[i].idIva.descripcion === 'Reducido (8%)') {
            this.editedItem.detalleProducto[i].baseImponible = (this.editedItem.detalleProducto[i].precioBs * this.editedItem.detalleProducto[i].devuelto)
            this.editedItem.detalleProducto[i].gravado += ((this.editedItem.detalleProducto[i].precioBs) * 0.08)
            this.editedItem.detalleProducto[i].total = this.editedItem.detalleProducto[i].gravado + this.editedItem.detalleProducto[i].subTotal
          } else {
            this.editedItem.detalleProducto[i].exento += this.editedItem.detalleProducto[i].precioBs
            this.editedItem.detalleProducto[i].total = this.editedItem.detalleProducto[i].exento
          }
          
          this.editedItem.subTotal += this.editedItem.detalleProducto[i].subTotal

          this.editedItem.gravado += this.editedItem.detalleProducto[i].gravado
          this.editedItem.exento += this.editedItem.detalleProducto[i].exento
          this.editedItem.baseImponible += this.editedItem.detalleProducto[i].baseImponible
        }
        this.editedItem.total = Math.round(this.editedItem.subTotal + this.editedItem.gravado)
      }
    },

    changeNota (val) {
      if (this.devolP) {
        this.editedItem.subTotal = 0
        this.editedItem.gravado = 0
        this.editedItem.exento = 0
        this.editedItem.baseImponible = 0
        this.editedItem.total = 0
        val.subTotal = Math.round(parseInt(val.devuelto) * val.precioBs)
        this.calculosP(val)
      } else if (this.devolT) {
        this.editedItem.subTotal = 0
        this.editedItem.gravado = 0
        this.editedItem.exento = 0
        this.editedItem.baseImponible = 0
        this.editedItem.total = 0
        val.subTotal = Math.round(parseInt(val.devuelto) * val.precioBs)
        this.calculosT()
      } else if (this.desc) {
        val.gravado = 0
        val.exento = 0
        val.baseImponible = 0
        val.subTotal = 0
        val.total = 0
        if (val.descuento !== '') {
          const porc = (parseFloat(val.descuento) / 100)
          if (val.detalleProducto.length > 0) {
            for (let i = 0; i < val.detalleProducto.length; i++) {
              if (val.detalleProducto[i].idIva.descripcion === 'Normal (16%)') {
                val.detalleProducto[i].subTotal = (val.detalleProducto[i].precioBs * val.detalleProducto[i].despachada)
                val.detalleProducto[i].baseImponible = val.detalleProducto[i].subTotal
                val.detalleProducto[i].gravado = (val.detalleProducto[i].subTotal * 0.16)
                val.detalleProducto[i].total = val.detalleProducto[i].gravado + val.detalleProducto[i].subTotal
                val.subTotal += Math.round(val.detalleProducto[i].subTotal)
                val.gravado += Math.round(val.detalleProducto[i].gravado)
                val.baseImponible += Math.round(val.detalleProducto[i].baseImponible)
              } else if (val.detalleProducto[i].idIva.descripcion === 'Reducido (8%)') {
                val.detalleProducto[i].subTotal = (val.detalleProducto[i].precioBs * val.detalleProducto[i].despachada)
                val.detalleProducto[i].baseImponible = val.detalleProducto[i].subTotal
                val.detalleProducto[i].gravado = (val.detalleProducto[i].subTotal * 0.08)
                val.detalleProducto[i].total = val.detalleProducto[i].gravado + val.detalleProducto[i].subTotal
                val.subTotal += Math.round(val.detalleProducto[i].subTotal)
                val.gravado += Math.round(val.detalleProducto[i].gravado)
                val.baseImponible += Math.round(val.detalleProducto[i].baseImponible)
              } else {
                val.detalleProducto[i].subTotal = (val.detalleProducto[i].precioBs * val.detalleProducto[i].despachada)
                val.detalleProducto[i].exento = val.detalleProducto[i].subTotal
                val.detalleProducto[i].total = val.detalleProducto[i].subTotal
                val.exento += Math.round(val.detalleProducto[i].exento)
                val.subTotal += Math.round(val.detalleProducto[i].subTotal)
              }
            }
          }
          val.subTotal = val.subTotal - (val.subTotal * porc)
          val.total = Math.round(val.subTotal + val.gravado)
        } else {
          val.subTotal = 0
          val.descuento = 0
        }
      }
    },

    changeTipoNota () {
      this.headers = [
        { text: 'Producto', value: 'idProducto.nombre' },
        { text: 'Cant. Actual ', value: 'cantidadActual' },
        { text: 'Despachada ', value: 'despachada' },
        { text: 'Precio(Bs)', value: 'precioBs' },
        { text: 'Sub Total', value: 'subTotal' },
        { text: 'IVA', value: 'idIva.descripcion' },
        { text: 'Monto Total', value: 'total' }
      ]
      let idnota = this.editedItem.idTipoNotaCredito
      const tip = this.tipoNotaCredito.find(tip => tip._id === idnota)
      this.descripcionNota = tip.descripcion
      this.editedItem.subTotal = 0
      this.editedItem.gravado = 0
      this.editedItem.exento = 0
      this.editedItem.baseImponible = 0
      this.editedItem.total = 0
      // delete this.editedItem.descuento
      for (let i = 0; i < this.editedItem.detalleProducto.length; i++) {
        this.editedItem.detalleProducto[i].devuelto = 0
        this.editedItem.detalleProducto[i].subTotal = 0
        this.editedItem.detalleProducto[i].total = 0
        this.editedItem.detalleProducto[i].gravado = 0
        this.editedItem.detalleProducto[i].exento = 0
        this.editedItem.detalleProducto[i].baseImponible = 0

        this.editedItem.detalleProducto[i].idAlmacen = ''
      }
      if (tip.descripcion === 'DEVOLUCION PARCIAL') {
        this.devolP = true
        if (this.desc) this.desc = false
        if (this.devolT) this.devolT = false
      }
      if (tip.descripcion === 'DESCUENTO') {
        this.desc = true
        if (this.devolP) this.devolP = false
        if (this.devolT) this.devolT = false
        this.editedItem.descuento = 0
        this.changeNota(this.editedItem)
        for (let i = 0; i < this.editedItem.detalleProducto.length; i++) {
          this.editedItem.detalleProducto[i].idAlmacen = null
        }
      }
      if (tip.descripcion === 'DEVOLUCION TOTAL') {
        this.devolT = true
        if (this.devolP) this.devolP = false
        if (this.desc) this.desc = false
        for (let i = 0; i < this.editedItem.detalleProducto.length; i++) {
          this.editedItem.detalleProducto[i].devuelto = this.editedItem.detalleProducto[i].despachada
          this.changeNota(this.editedItem.detalleProducto[i])
        }
      }
    },

    formato (fecha) {
      return this.$moment(fecha).format('YYYY-MM-DD, HH:mm')
    },

    validarCrear () {
      return true
      // return this.permisosRuta.accion.includes("Crear");
    },
    validarModificar () {
      return true
      // return this.permisosRuta.accion.includes("Modificar");
    },
    validarEliminar () {
      return true
      // return this.permisosRuta.accion.includes("Eliminar");
    },

    close () {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.editedItem.detalleProducto = []
        this.read = false
        this.devolP = false
        this.headers = [
          { text: 'Producto', value: 'idProducto.nombre' },
          { text: 'Cant. Actual ', value: 'cantidadActual' },
          { text: 'Despachada ', value: 'despachada' },
          { text: 'Precio', value: 'precio' },
          { text: 'Sub Total', value: 'subTotal' },
          { text: 'IVA', value: 'idIva.descripcion' },
          { text: 'Monto Total', value: 'total' }
        ]
      }, 300)
      this.$emit('venta')
      this.$emit('close')
    },

    closeF () {
      this.dialogFacturaNotaCredito = false
    },

    closeF2 () {
      this.dialogFacturaNotaCreditoDescuento = false
    },

    validarCantidades () {
      for (let i = 0; i < this.editedItem.detalleProducto.length; i++) {
        if (this.devolP) {
          if (
            this.editedItem.detalleProducto[i].devuelto > this.editedItem.detalleProducto[i].despachada) {
            this.$swal({
              icon: 'error',
              title: 'Error en las cantidades',
              text: 'Las cantidades a devolver no pueden ser mayor a la despachada'
            })
            return true
          }
        }
      }
      return false
    },

    validarCampos () {
      if (this.editedItem.observacion === '') {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Debe colocar una observación'
        })
        return true
      }
      if (this.editedItem.idTipoNotaCredito === '') {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Debe seleccionar un tipo de nota de Credito'
        })
        return true
      } else {
        if (this.descripcionNota === 'DEVOLUCION PARCIAL') {
          let bool = false
          for (let i = 0; i < this.editedItem.detalleProducto.length; i++) {
            if (this.editedItem.detalleProducto[i].devuelto > 0) bool = true
            if (this.editedItem.detalleProducto[i].devuelto > 0 && this.editedItem.detalleProducto[i].idAlmacen === '') {
              this.$swal({
                icon: 'error',
                title: 'Error',
                text: 'Debe seleccionar un almacen'
              })
              return true
            }
          }
          if (!bool) {
            this.$swal({
              icon: 'error',
              title: 'Error',
              text: 'No ha seleccionado ningun producto a devolver'
            })
            return true
          }
        }
      }
      return false
    },

    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    },

    save () {
      if (!this.validarCampos() && !this.validarCantidades()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        this.editedItem.debito = 0
        this.editedItem.credito = this.editedItem.total
        Api.post('notacredito', this.editedItem)
          .then(response => {
            let array = {}
            this.editedItem.numNotaCredito = response.data.numNotaCredito
            this.$emit('save')
            this.$swal({
              icon: 'success',
              title: 'Creación exitosa',
              text: 'Todos los cambios han sido efectuados'
            })
            // Bus a FacturaNotaCredito.vue
            if (this.devolP) {
              array = {
                editedItem: this.editedItem,
                valor: 'parcial'
              }
              EventBus.$emit('dataFacturaNotaCredito', array)
              this.dialogFacturaNotaCredito = true
            } else if (this.devolT) {
              array = {
                editedItem: this.editedItem,
                valor: 'total'
              }
              EventBus.$emit('dataFacturaNotaCredito', array)
              this.dialogFacturaNotaCredito = true
            } else if (this.desc) {
              EventBus.$emit('dataFacturaNotaCreditoDescuento', this.editedItem)
              this.dialogFacturaNotaCreditoDescuento = true
            }
            this.close()
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message);
            }
          })
      }
    }
  }
}
</script>
